import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "filler" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted font-size-small mt-2"
}
const _hoisted_4 = { class: "ml-2" }

import {computed} from 'vue';
import {IOperator, IOperatorGroup} from "~/chat/ts/data/IOperator";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import ChatSelectableItem from "~/chat/vue/misc/ChatSelectableItem.vue";
import Avatars from "~/chat/vue/widget/operators/select/Avatars.vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "Group"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    group: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let visibleOperatorsOfGroup = computed(() => {
    return OperatorsStore.isOffline.value ? OperatorsStore.getOperatorsOfGroup(props.group) : OperatorsStore.getVisibleOperatorsOfGroup(props.group);
});

function onAvatarClick(payload: { operator: IOperator, originalEvent: MouseEvent }) {
    if (OperatorsStore.balanceType.value.selectRandomOperator) {
        payload.originalEvent.stopPropagation();
        emits("click", payload.operator);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatSelectableItem, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.group.descr), 1),
          (!_unref(visibleOperatorsOfGroup).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(__)('OPERATOR_NOT_ONLINE')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Avatars, {
            onClick: onAvatarClick,
            operators: _unref(visibleOperatorsOfGroup)
          }, null, 8, ["operators"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})